(() => {
  const instances = new Map();
  const sliderUtils = window.AWSliderCoreUtils;

  class AWProductVoice {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-aw-product-voice-viewport]");
      this.scrollbar = root.querySelector("[data-aw-product-voice-scrollbar]");
      this.thumb = root.querySelector("[data-aw-product-voice-scrollbar-thumb]");
      this.scrollFrame = null;
      this.resizeFrame = null;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onImageLoad = this.onImageLoad.bind(this);

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      window.addEventListener("resize", this.onResize);

      sliderUtils.bindImageLoad(this.root, this.onImageLoad);
    }

    destroy() {
      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }

      if (this.resizeFrame) {
        window.cancelAnimationFrame(this.resizeFrame);
      }
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.update();
      });
    }

    onResize() {
      if (this.resizeFrame) return;

      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.update();
      });
    }

    onImageLoad() {
      this.onResize();
    }

    update() {
      if (!this.viewport || !this.scrollbar || !this.thumb) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      sliderUtils.updateScrollbar({
        viewport: this.viewport,
        scrollbar: this.scrollbar,
        thumb: this.thumb,
        enabled: hasOverflow
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-product-voice]").forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new AWProductVoice(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-product-voice]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroy(event.target);
  });
})();
